import theme from '@/common/styles/mui-theme';

const NAVIGATION_WIDTH = 256;
const MOBILE_NAVIGATION_BREAKPOINT = theme.breakpoints.down('laptop');

const drawerBarStyles = {
  container: {
    position: 'relative',
    width: 'fit-content',
    height: '100%',
    borderRight: '1px solid',
    borderColor: 'divider',
    [MOBILE_NAVIGATION_BREAKPOINT]: {
      width: '100%',
      height: 'fit-content',
    },
  },
  mobileHeader: {
    display: 'none',
    backgroundColor: '#FFFFFF',
    [MOBILE_NAVIGATION_BREAKPOINT]: {
      display: 'block',
    },
  },
  mobileHeaderToolbar: {
    justifyContent: 'space-between',
    px: 4,
    py: 1.5,
  },
  desktopDrawer: {
    width: `${NAVIGATION_WIDTH}px`,
    height: '100%',
    flexShrink: 0,
    zIndex: 0,
    [MOBILE_NAVIGATION_BREAKPOINT]: {
      display: 'none',
    },
    '& .MuiDrawer-paper': {
      position: 'relative',
      zIndex: 0,
      width: `${NAVIGATION_WIDTH}px`,
      boxSizing: 'border-box',
      borderRight: 'none',
      overflow: 'hidden',
    },
  },
  mobileDrawer: {
    display: 'none',
    [MOBILE_NAVIGATION_BREAKPOINT]: {
      display: 'block',
    },
    '& .MuiDrawer-paper': {
      width: `${NAVIGATION_WIDTH}px`,
      boxSizing: 'border-box',
      borderRight: 'none',
    },
  },
  drawerContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: '#FFFFFF',
  },
  navigationLogo: {
    height: '38px',
  },
  navigationList: {
    display: 'flex',
    flexDirection: 'column',
    p: 2,
  },
  navigationListItem: {
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 16px',
    alignItems: 'center',
    textDecoration: 'none',
    gap: '12px',

    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '24px',

    color: '#000000',
    '& span': {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    '& svg': {
      marginRight: '8px',
      color: 'text.tertiary',
    },
  },
  navigationListItemContent: {
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  navigationListItemAdornment: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    color: 'text.tertiary',
    opacity: 0,
    transition: 'opacity 0.2s ease, color 0.2s ease',
    '& svg': {
      marginRight: 0,
      color: 'inherit',
    },
  },
  navigationListItemAdornmentVisible: {
    '&:hover .navigation-list-item-adornment, &:focus-visible .navigation-list-item-adornment':
      {
        opacity: 1,
      },
  },
  navigationListItemActive: {
    color: 'system.green',
    background:
      'linear-gradient(0deg, rgba(51, 143, 108, 0.08), rgba(51, 143, 108, 0.08)), linear-gradient(0deg, #FFFFFF, #FFFFFF)',
    fontWeight: 500,
    '& svg': {
      color: 'system.green',
    },
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    mt: 'auto',
  },
  footerLinks: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: '16px',
    px: 6,
    py: 2,
    fontSize: '12px',
    lineHeight: '20px',
    letterSpacing: '0.16px',
    fontFamily: '"Red Hat Text", sans-serif',
    borderTop: '1px solid',
    borderColor: 'divider',
    '& a': {
      minWidth: 0,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      textAlign: 'center',
      color: 'var(--text-secondary-color)',
    },
    '& a:visited': {
      color: 'var(--text-secondary-color)',
    },
  },
  info: {
    m: 2,
    px: 4,
    py: 3.5,
  },
  infoActive: {
    background:
      'linear-gradient(0deg, rgba(51, 143, 108, 0.08), rgba(51, 143, 108, 0.08))',

    color: 'system.green',
    '& .MuiTypography-root': {
      color: 'inherit',
    },
    '& .MuiTypography-body2': {
      color: 'text.tertiary',
    },
    '& .MuiButton-endIcon svg': {
      color: 'text.tertiary',
    },
  },
  infoContaniner: {
    maxWidth: '183px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  infoBodyFullname: {
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textAlign: 'left',
  },
  infoBodyEmail: {
    fontSize: '16px',
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    color: 'text.tertiary',
    textAlign: 'left',
  },
};

export default drawerBarStyles;
